/* istanbul ignore file */

/* Leads to the review's own drawer, where the review and the partner's reply are both
   shown in full, rather than expanding anything on the card. */
export const READ_MORE = 'Read more';
export const REPLY_PREFIX = 'Read';
export const REPLY_SUFFIX = 'reply';
export const VIEW_ALL_PHOTOS = 'View all photos';
/* The whole card's link, for a review with no control of its own to click. */
export const READ_REVIEW = 'Read review';
